import { css } from '@inter-ikea-kompis/web-component';
import KeyboardTransition from '../../enums/KeyboardTransition.js';
/**
 * Keyboard style.
 */
export default class KeyboardInjectorStyle {
    /**
     * Returns style.
     *
     * @param options Options.
     * @param options.offsetY OffsetY y.
     * @returns Keyboard CSS.
     */
    static getStyle(options) {
        return css `
			:host {
				position: fixed;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
			}

			.app {
				overflow-y: auto;
				overflow-x: hidden;
				scroll-behavior: smooth;
				max-height: 100%;
				max-width: 100%;
				height: 100%;
				top: -${options.offsetY}px;
				transition: ${KeyboardTransition.timingFunction} ${KeyboardTransition.duration}ms;
				transition-property: top;
				position: relative;
			}

			@media print {
				kompis-keyboard {
					display: none;
				}
				:host {
					position: relative;
				}
			}
		`;
    }
}
//# sourceMappingURL=KeyboardInjectorStyle.js.map